import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (data) => api.post('/auth/register', data);
export const getMe = () => api.get('/auth/me');

// Teams
export const getTeams = () => api.get('/teams');
export const getTeam = (id) => api.get(`/teams/${id}`);

// Products
export const getProducts = (category) => api.get('/products', { params: { category } });
export const getProduct = (id) => api.get(`/products/${id}`);

// Classes
export const getClasses = (sport) => api.get('/classes', { params: { sport } });
export const getClass = (id) => api.get(`/classes/${id}`);

// Rental Spaces
export const getRentalSpaces = (spaceType) => api.get('/rentals', { params: { space_type: spaceType } });
export const getRentalSpace = (id) => api.get(`/rentals/${id}`);

// Bookings
export const createBooking = (data) => api.post('/bookings', data);
export const getBookings = () => api.get('/bookings');
export const cancelBooking = (id) => api.delete(`/bookings/${id}`);

// Cart
export const getCart = () => api.get('/cart');
export const addToCart = (productId, quantity = 1) => api.post('/cart/add', { product_id: productId, quantity });
export const removeFromCart = (productId) => api.post('/cart/remove', { product_id: productId });
export const clearCart = () => api.post('/cart/clear');

// Checkout
export const createCheckoutSession = (originUrl) => api.post('/checkout/session', { origin_url: originUrl });
export const getCheckoutStatus = (sessionId) => api.get(`/checkout/status/${sessionId}`);

// Seed data
export const seedData = () => api.post('/seed');

export default api;
